export default __webpack_public_path__ + "static/media/moleculeBg.d9b1bebc.jpg";